export default "__VITE_ASSET__2tgg$uR3__"